module.exports = __webpack_public_path__ + "img/toughMinded1.e7b85cdb.png";